import { theme } from '@certificate/components';
import { ConfigProvider } from '@certificate/configuration';
import { Routes } from '@generouted/react-router';
import * as Sentry from '@sentry/react';
import { ApolloProvider, createApolloClient } from '@shared/apollo';
import { getExternalForceLogout } from '@shared/auth';
import { ThemeProvider, CssBaseline } from '@shared/components';
import { LoggerProvider } from '@shared/logger';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';

import { configuration } from './configuration';

const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn && !import.meta.env.DEV) {
  Sentry.init({
    dsn,
    sendDefaultPii: true,
    environment: import.meta.env.MODE,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const { logLevel, graphql } = configuration;
const defaultFetchPolicy = graphql.defaultFetchPolicy ?? 'cache-first';

const client = createApolloClient(
  graphql.apiUrl,
  {
    query: { fetchPolicy: defaultFetchPolicy },
    watchQuery: { fetchPolicy: defaultFetchPolicy },
  },
  {
    onUnauthorized: () => getExternalForceLogout()?.(),
  },
);

root.render(
  <StrictMode>
    <ConfigProvider config={configuration}>
      <ApolloProvider client={client}>
        <LoggerProvider config={{ level: logLevel, enableConsole: true }}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Routes />
          </ThemeProvider>
        </LoggerProvider>
      </ApolloProvider>
    </ConfigProvider>
  </StrictMode>,
);
